import {KeycloakRoleEnum} from "./enums/keycloak-role.enum";

export const routeRoleConfig = {
    home: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.CUSTOMER],
    applications: [KeycloakRoleEnum.ADMIN],
    translations: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.CUSTOMER],
    query: [KeycloakRoleEnum.ADMIN],
    settings: [KeycloakRoleEnum.ADMIN],
    appSettings: [KeycloakRoleEnum.ADMIN],
    jsonata: [KeycloakRoleEnum.ADMIN],
};
